import * as React from 'react'

import StudentDeleteField from '@frontrow/console/src/components/pages/students-page/student-delete/student-delete-field'
import {deleteStudentData} from '@frontrow/console/src/helpers/api-students'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

export function StudentDelete(): React.ReactElement {
  const [isDeleting, setIsDeleting] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const deleteStudent = async (studentId: number): Promise<void> => {
    setIsDeleting(true)
    setError(null)

    try {
      await deleteStudentData(studentId)
      setIsDeleting(false)
    } catch (err: unknown) {
      const apiError = firstResponseApiError(err)
      setError(apiError.message)
      setIsDeleting(false)
    }
  }

  return <StudentDeleteField error={error} isDeleting={isDeleting} deleteStudent={deleteStudent} />
}
